import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_satelital_image_modal_component = _resolveComponent("satelital-image-modal-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: _ctx.chartId,
              style: {"width":"100%","height":"35vh"}
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      "show-close": true,
      title: _ctx.parameterName
    }, [
      _createVNode(_component_satelital_image_modal_component, {
        visible: _ctx.imgVisible,
        title: _ctx.parameterName,
        images: [_ctx.image],
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imgVisible = false))
      }, null, 8, ["visible", "title", "images"])
    ], 8, _hoisted_2), [
      [_vShow, _ctx.imgVisible]
    ])
  ], 64))
}